import cryptoJs from 'crypto-js';
import hmacSHA256 from 'crypto-js/hmac-sha256';

async function apiCall(apiKey, key, sig) {
    const recWindow = 30000; // # 30 seconds
    const timestamp = Date.now();
    const query = "recvWindow="+recWindow+"&timestamp="+timestamp;
    if (!sig) {
        sig = hmacSHA256(query, key).toString(cryptoJs.enc.Hex);
    }

    const res = await (await fetch('https://sandbox.arkerlabs.com:4028', {
        method: 'POST',
        body: JSON.stringify({
            url: 'https://api.binance.com/api/v3/account?recvWindow='+recWindow+'&timestamp='+timestamp+'&signature='+sig,
            method: 'GET',
            apiKey: '076107cc890641aa403b21c145f65920bf9bdb0744d9078d0fb71b2ddab68443',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-MBX-APIKEY': apiKey,
            }
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    })).json();

    const balances = {btc: 0, usdt: 0};
    for (const balance of res.balances) {
        for (const asset of Object.keys(balances)) {
            if (balance.asset.toLowerCase() === asset) {
                balances[asset] = balance.free;
            }
        }
    }
    return balances;
}

export default apiCall;